"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Accordion_1 = require("./Accordion");
exports.default = Accordion_1.default;
//# sourceMappingURL=index.js.map